import React, { FC, useState } from 'react';
import { Input, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FormInstance } from 'antd/lib/form';

import { Form } from '~/components';
import CurrencyInput from './CurrencyInput';

interface Props {
  name?: string;
  required?: boolean;
  disabled?: boolean;
  disabledCurrency?: boolean;
  currencyFilter?: (currency: string) => boolean;
  className?: string;
  form: FormInstance;
  min?: number;
  max?: number;
  [key: string]: any;
}

const AmountInput: FC<Props> = React.forwardRef((props, ref) => {
  const {
    name = 'amount',
    required,
    className,
    disabled,
    disabledCurrency,
    currencyFilter,
    form,
    min,
    max,
  } = props;
  const [t] = useTranslation();

  const [currencyRequired, setCurrencyRequired] = useState(false);

  const handleAmountValue = () => {
    if (!form) return;
    const amount = form.getFieldsValue()[name] as { value?: number; currency?: string };

    if (!currencyRequired && amount.value?.toString()) {
      setCurrencyRequired(true);
    } else if (currencyRequired && !amount.value?.toString()) {
      setCurrencyRequired(false);
    }
  };

  return (
    <Input.Group className={className}>
      <Form.Item name={[name, 'value']} noStyle rules={[{ required, type: 'number' }]}>
        <InputNumber
          className="AmountInput-Value"
          onChange={handleAmountValue}
          placeholder={t('value')}
          disabled={disabled}
          min={min}
          max={max}
          ref={ref as any}
        />
      </Form.Item>
      <Form.Item
        name={[name, 'currency']}
        noStyle
        rules={[{ required: currencyRequired || required }]}
      >
        <CurrencyInput
          className="AmountInput-Currency"
          placeholder={t('currency')}
          disabled={disabled || disabledCurrency}
          currencyFilter={currencyFilter}
        />
      </Form.Item>
    </Input.Group>
  );
});

export default styled(AmountInput)`
  display: flex;
  .AmountInput-Value {
    width: 50%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }
  .AmountInput-Currency {
    width: 50% !important;
    .ant-select-selector {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
